import styled from '@emotion/styled';
import { SectionTitle } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalSectionTitle = styled(SectionTitle)`
  ${responsiveFontSize(32, 4)}
`;

export const ButtonsContainer = styled.div`
  margin-top: auto;
`;

export const DekstopImage = styled.img`
  object-fit: cover;
  align-self: center;
  width: 250px;
  box-shadow: 0 0 10px 5px rgb(0 0 0 / 5%);
  border-radius: 10px;
  height: 100%;
  margin-bottom: 15px;
  ${mediaQuery('tablet')} {
    max-height: auto;
    max-width: 250px;
    width: 60%;
  }
  ${mediaQuery('phone')} {
    display: none;
  }
`;

export const SectionText = styled.div`
  font-size: 16px;
  font-weight: 400;
  white-space: pre-wrap;
`;
